module.exports = __webpack_public_path__ + "static/media/3.be9e1de4.jpg";